// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (min-width: 1281px){.profile-steps{display:none}}@media only screen and (max-width: 1280px){.profile-steps{margin-top:48px;margin-bottom:48px;display:flex;flex-direction:column;align-items:center}.profile-steps h3{margin-bottom:16px;font-weight:bold;font-size:20px;line-height:24px}.profile-steps img{width:156px;height:auto;margin:0 !important}}", ""]);
// Exports
module.exports = exports;
